import {
  getScanGroup,
  getScanTask,
  type ScanGroupOptimized,
  type ScanPartContext,
  type ScanPhoto,
  type ScanRootOptimized,
  type ScanTaskOptimized,
} from '@kaiizen/kai-scan-template-system';

import type { ScanAudioAttachScope } from './scanAudioScopeLib';

/** ScanPhoto provenance for a toolbox frame capture (mirrors VideoToScopeJob photo metadata). */
export const buildVideoFrameScanPhoto = (
  basePhoto: ScanPhoto,
  scanVideoId: string,
  videoFrameTimeSeconds: number,
): ScanPhoto => ({
  ...basePhoto,
  scanVideoId,
  videoFrameTimeSeconds,
});

export type VideoToolboxFrameCaptureTarget = {
  scanPart: ScanGroupOptimized | ScanTaskOptimized;
  scanPartIds: ScanPartContext;
};

/** Resolves the scan part + mutator ids for the editor's current attach scope (group or task). */
export const resolveVideoToolboxFrameCaptureTarget = (
  scanRoot: ScanRootOptimized,
  attachScope: ScanAudioAttachScope,
): VideoToolboxFrameCaptureTarget | undefined => {
  if (attachScope.taskId && attachScope.groupId) {
    return {
      scanPart: getScanTask(scanRoot, attachScope.groupId, attachScope.taskId),
      scanPartIds: { groupId: attachScope.groupId, taskId: attachScope.taskId },
    };
  }
  if (attachScope.groupId) {
    return {
      scanPart: getScanGroup(scanRoot, attachScope.groupId),
      scanPartIds: { groupId: attachScope.groupId },
    };
  }
  return undefined;
};
